import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Package, Calendar, DollarSign, Hash } from 'lucide-react';

const AssetListItem = ({ asset, delay = 0 }) => {
  const getTypeLabel = (type) => {
    const types = {
      appliance: 'Appliance',
      vehicle: 'Vehicle',
      hvac: 'HVAC',
      plumbing: 'Plumbing',
      other: 'Other'
    };
    return types[type] || type;
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.3 }}
    >
      <Link to={`/asset/${asset.id}`}>
        <div className="glassmorphic-hover p-4 hover:cursor-pointer">
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="text-lg font-medium text-foreground truncate">{asset.name}</h3>
              </div>
              <p className="text-sm text-muted-foreground mb-2">{getTypeLabel(asset.type)}</p>
              <div className="flex flex-wrap items-center gap-4 text-sm text-body">
                {asset.purchaseDate && (
                  <div className="flex items-center">
                    <Calendar className="h-4 w-4 mr-1.5" />
                    <span>{new Date(asset.purchaseDate).toLocaleDateString()}</span>
                  </div>
                )}
                {asset.cost && (
                  <div className="flex items-center">
                    <DollarSign className="h-4 w-4 mr-1.5" />
                    <span>${parseFloat(asset.cost).toFixed(2)}</span>
                  </div>
                )}
                {asset.serialNumber && (
                  <div className="flex items-center">
                    <Hash className="h-4 w-4 mr-1.5" />
                    <span className="truncate max-w-[150px]">{asset.serialNumber}</span>
                  </div>
                )}
              </div>
              {asset.notes && (
                <p className="mt-2 text-sm text-body line-clamp-1">{asset.notes}</p>
              )}
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default AssetListItem;

